export default __webpack_public_path__ + "static/media/Clojure_logo.720a910b.svg";